/* EWC · FAQ da home — sanfona com mouse e teclado */
(function () {
  function ligar(raiz) {
    if (!raiz || raiz.getAttribute('data-ewc-faq') === 'pronto') return;
    raiz.setAttribute('data-ewc-faq', 'pronto');

    var lista = raiz.querySelector('.faq-container');
    if (!lista) return;
    var umaPorVez = lista.getAttribute('data-accordion') === 'true';
    var itens = Array.prototype.slice.call(lista.querySelectorAll('.faq-item'));

    itens.forEach(function (item) {
      var pergunta = item.querySelector('.faq-question');
      if (!pergunta) return;

      function alternar() {
        var aberto = item.classList.contains('active');
        if (umaPorVez && !aberto) {
          itens.forEach(function (outro) {
            outro.classList.remove('active');
            var p = outro.querySelector('.faq-question');
            if (p) p.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('active');
        pergunta.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
      }

      pergunta.addEventListener('click', alternar);
      pergunta.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
          ev.preventDefault();
          alternar();
        }
      });
    });
  }


  /* a referência marca pergunta e resposta com .mobile-font abaixo de 750px */
  function fontesCelular() {
    var celular = window.innerWidth < 750;
    Array.prototype.forEach.call(
      document.querySelectorAll('.store-faq-section .faq-question, .store-faq-section .faq-answer'),
      function (el) { el.classList.toggle('mobile-font', celular); }
    );
  }
  window.addEventListener('resize', fontesCelular);

  function ligarTodos() {
    Array.prototype.forEach.call(document.querySelectorAll('.store-faq-section'), ligar);
    fontesCelular();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligarTodos);
  } else {
    ligarTodos();
  }
  document.addEventListener('shopify:section:load', ligarTodos);
})();
